export const consultantName = (consultant: GQL.IConsultant): string => {
  return `${consultant.lastName} ${consultant.firstName}`;
};

export const consultantNumberAndName = (consultant: GQL.IConsultant): string => {
  return `${!consultant.isSystem && consultant.number ? `${consultant.number}: ` : ``}${consultant.lastName} ${consultant.firstName}`;
};
